import { log, warn, error } from '@/utils/debugLogger';
import { ForgeInspection, ForgeAvaInspect } from "@/scripts/js/forgeModels";
import inspectionService from "../services/inspectionService";
import avaInspectService from "../services/avaInspect.service";
import store from "@/store";

export const INSPECTION_VIEW = {
  namespaced: true,
  state: {
    // AbortController for cancelling pending requests
    currentRequestController: null,
    isLoading: false,
  },
  getters: {
    GET_CURRENT_REQUEST_CONTROLLER: (state) => state.currentRequestController,
    GET_IS_LOADING: (state) => state.isLoading,
  },
  mutations: {
    SET_REQUEST_CONTROLLER(state, controller) {
      state.currentRequestController = controller;
    },
    CLEAR_REQUEST_CONTROLLER(state) {
      state.currentRequestController = null;
    },
    SET_IS_LOADING(state, value) {
      state.isLoading = value;
    },
  },
  actions: {
    GET_BY_ID({ rootState }, id) {
      return inspectionService.getById(id, rootState.assetId).then(({ data }) => {
        let tag = Object.assign(new ForgeInspection(), data);
        tag.parseContent();
        return tag;
      });
    },
    GET_AVA_INSPECT_BY_ID({ rootState }, id) {
      return avaInspectService.getById(id, rootState.assetId).then(({ data }) => {
        let tag = Object.assign(new ForgeAvaInspect(), data);
        tag.parseContent();
        return tag;
      });
    },
    LOAD_INSPECTIONS({ commit, state }, reload) {
      // Cancel any existing request before starting a new one
      if (state.currentRequestController) {
        state.currentRequestController.abort();
      }

      // Create new AbortController for this request
      const controller = new AbortController();
      commit('SET_REQUEST_CONTROLLER', controller);

      let text = store.getters['GET_AMIS_SEARCH_TEXT'];

      const forgeService = store.state.forgeService;

      if (!forgeService) {
        error('No forgeService found');
        commit('CLEAR_REQUEST_CONTROLLER');
        return;
      }

      commit('SET_IS_LOADING', true);

      // Pass signal to forgeService if it supports it
      return forgeService.loadInspectionTagsAdvanced(text, reload, controller.signal)
        .catch(err => {
          // Don't show error for cancelled requests
          if (err?.name !== 'AbortError' && err?.name !== 'CanceledError') {
            throw err;
          }
        })
        .finally(() => {
          commit('SET_IS_LOADING', false);
          commit('CLEAR_REQUEST_CONTROLLER');
        });
    },
    /**
     * Cancel any pending request
     */
    CANCEL_CURRENT_REQUEST({ commit, state }) {
      if (state.currentRequestController) {
        state.currentRequestController.abort();
        commit('CLEAR_REQUEST_CONTROLLER');
        commit('SET_IS_LOADING', false);
      }
    },
  }
}
